import {Directive} from '@angular/core';
import {GoogleMapsAPIWrapper} from 'angular2-google-maps/core/services';

@Directive({
    selector: 'satellite-map'
})
export class SatelliteMapDirective {

    constructor(private googleMapsAPIWrapper: GoogleMapsAPIWrapper) {
        this.googleMapsAPIWrapper.getNativeMap().then((map:any) => {
            (map as google.maps.Map).setMapTypeId('hybrid');
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/satelliteMap/satelliteMap.directive.ts